export default "__VITE_PUBLIC_ASSET__3a159cee__"